<template>
  <label
    :aria-checked="value === label"
    :aria-disabled="isDisabled"
    class="s-radio-button"
    :class="[
      { 'is-active': value === label },
      { 'is-disabled': isDisabled },
      { 'is-focus': focus }
    ]"
    role="radio"
    :tabindex="tabIndex"
    @keydown.space.stop.prevent="value = isDisabled ? value : label">
    <input
      v-model="value"
      class="s-radio-button__orig-radio"
      data-qa="radio"
      :disabled="isDisabled"
      :name="name"
      :state="value === label ? 'check' : 'uncheck'"
      tabindex="-1"
      type="radio"
      :value="label"
      @blur="focus = false"
      @change="handleChange"
      @focus="focus = true">
    <span
      class="s-radio-button__inner"
      data-qa="radio__label"
      :style="value === label ? activeStyle : null"
      @keydown.stop>
      <slot/>
      <template v-if="!$slots.default">{{ label }}</template>
    </span>
  </label>
</template>
<script>
import Form from '../../mixins/form.js'
import emitter from '../../mixins/emitter'

/**
 * Кнопка Radio
 * @displayName RadioButton
 */
export default {
  name: 'sRadioButton',
  mixins: [emitter, Form],
  props: {
    /**
     * значение
     */
    label: {
      type: [String, Number],
    },
    /**
     * отключение
     */
    disabled: {
      type: Boolean,
    },
    /**
     * собственный атрибут 'name'
     * @ignore
     */
    name: {
      type: String,
    },
  },
  data() {
    return {
      focus: false
    }
  },
  computed: {
    value: {
      get() {
        return this._radioGroup.value
      },
      set(value) {
        this._radioGroup.$emit('input', value)
      }
    },
    _radioGroup() {
      let parent = this.$parent
      while (parent) {
        if (parent.$options.componentName !== 'sRadioGroup') {
          parent = parent.$parent
        } else {
          return parent
        }
      }
      return false
    },
    activeStyle() {
      return {
        backgroundColor: this._radioGroup.fill || '',
        borderColor: this._radioGroup.fill || '',
        boxShadow: this._radioGroup.fill ? `-1px 0 0 0 ${this._radioGroup.fill}` : '',
        color: this._radioGroup.textColor || ''
      }
    },
    isDisabled() {
      return this.disabled || this._radioGroup.disabled || (this.sForm || {}).disabled
    },
    tabIndex() {
      return (this.isDisabled || (this._radioGroup && this.value !== this.label)) ? -1 : 0
    }
  },
  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.dispatch('sRadioGroup', 'handleChange', this.value)
      })
    }
  }
}
</script>